export const ArchiveBox = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 0H0.5C0.223437 0 0 0.223437 0 0.5V13.5C0 13.7766 0.223437 14 0.5 14H10.5C10.7766 14 11 13.7766 11 13.5V0.5C11 0.223437 10.7766 0 10.5 0ZM9.875 12.875H1.125V9.73438H2.65469C2.83594 10.2469 3.15469 10.7078 3.57812 11.0578C4.11719 11.5031 4.8 11.75 5.5 11.75C6.2 11.75 6.88281 11.5047 7.42188 11.0578C7.84531 10.7078 8.16406 10.2469 8.34531 9.73438H9.875V8.75H7.55625L7.475 9.13594C7.2875 10.0703 6.45625 10.75 5.5 10.75C4.54375 10.75 3.7125 10.0703 3.52344 9.13594L3.44219 8.75H1.125V1.125H9.875V12.875ZM2.5 4.32812H8.5C8.56875 4.32812 8.625 4.27188 8.625 4.20312V3.45312C8.625 3.38437 8.56875 3.32812 8.5 3.32812H2.5C2.43125 3.32812 2.375 3.38437 2.375 3.45312V4.20312C2.375 4.27188 2.43125 4.32812 2.5 4.32812ZM2.5 6.82812H8.5C8.56875 6.82812 8.625 6.77188 8.625 6.70312V5.95312C8.625 5.88437 8.56875 5.82812 8.5 5.82812H2.5C2.43125 5.82812 2.375 5.88437 2.375 5.95312V6.70312C2.375 6.77188 2.43125 6.82812 2.5 6.82812Z"
        fill="currentColor"
      />
    </svg>
  );
};
